import React, { CSSProperties, ReactNode } from "react";
import { useTheme } from "../context/ThemeContext";
import { getColorblindImageFilterStyle } from "../utils/colorAdjustment";

export function useColorblindImageFilter(): CSSProperties {
  const { theme } = useTheme();

  return getColorblindImageFilterStyle(
    theme.colorblindType,
    theme.isColorblindMode,
  );
}

type ColorblindImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

/**
 * Drop-in img replacement that applies colorblind simulation at display time.
 * The underlying image source is never modified.
 */
export const ColorblindImage: React.FC<ColorblindImageProps> = ({
  style,
  ...props
}) => {
  const filterStyle = useColorblindImageFilter();

  return <img {...props} style={{ ...style, ...filterStyle }} />;
};

type ColorblindImageContainerProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

/**
 * Wrapper for inline SVG or mixed image content that needs the same filter.
 */
export const ColorblindImageContainer: React.FC<
  ColorblindImageContainerProps
> = ({ children, className, style }) => {
  const filterStyle = useColorblindImageFilter();

  return (
    <div className={className} style={{ ...style, ...filterStyle }}>
      {children}
    </div>
  );
};
